<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12 reveal-1" v-scroll-reveal.reset="{ delay: 0 }">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Semua PO yang masih tersedia</h3>
            <div class="form-group">
              <input class="form-control" placeholder="Pencarian" type="text" v-model="search" />
            </div>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-9 col-md-10 mb-3 mb-sm-5 mt-3 mt-lg-5"
          v-for="post in filteredList"
          v-bind:key="post.title"
          v-scroll-reveal.reset="{ delay: 300 }"
        >
          <div class="card card-body hover-box-shadow">
            <img
              v-bind:src="post.img"
              alt="Joshua Lapinsky profile image"
              class="avatar mt-md-n5 mb-3"
            />
            <div>
              <div class="text-muted mb-3">Pipit Agustin, Surabaya</div>
              <a href>
                <router-link to="/detailpo" tag="h4">{{ post.title }}</router-link>
              </a>
              <p class="primary lead mb-3">
                <strong>Rp 15,000 - 100,000</strong>
              </p>

              <div class="d-flex justify-content-between align-items-center">
                <a href="#" class="badge badge-pill badge-info">Pre Order</a>
                <div class="text-small text-muted">30 Hari Lagi</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
class Post {
  constructor(title, link, author, img) {
    this.title = title;
    this.link = link;
    this.author = author;
    this.img = img;
  }
}

export default {
  name: "ListPo",
  data: function() {
    return {
      search: "",
      sort: "",
      postList: [
        new Post(
          "Vue.js",
          "https://vuejs.org/",
          "Chris",
          "https://vuejs.org//images/logo.png"
        ),
        new Post(
          "React.js",
          "https://facebook.github.io/react/",
          "Tim",
          "https://daynin.github.io/clojurescript-presentation/img/react-logo.png"
        ),
        new Post(
          "Angular.js",
          "https://angularjs.org/",
          "Sam",
          "https://angularjs.org/img/ng-logo.png"
        ),
        new Post(
          "Ember.js",
          "http://emberjs.com/",
          "Rachel",
          "http://www.gravatar.com/avatar/0cf15665a9146ba852bf042b0652780a?s=200"
        ),
        new Post(
          "Meteor.js",
          "https://www.meteor.com/",
          "Chris",
          "http://hacktivist.in/introduction-to-nodejs-mongodb-meteor/img/meteor.png"
        ),
        new Post(
          "Aurelia",
          "http://aurelia.io/",
          "Tim",
          "https://cdn.auth0.com/blog/aurelia-logo.png"
        ),
        new Post(
          "Node.js",
          "https://nodejs.org/en/",
          "A. A. Ron",
          "https://code-maven.com/img/node.png"
        ),
        new Post(
          "Pusher",
          "https://pusher.com/",
          "Alex",
          "https://avatars1.githubusercontent.com/u/739550?v=3&s=400"
        ),
        new Post(
          "Feathers.js",
          "http://feathersjs.com/",
          "Chuck",
          "https://cdn.worldvectorlogo.com/logos/feathersjs.svg"
        )
      ]
    };
  },
  computed: {
    filteredList() {
      return this.postList.filter(post => {
        return post.title.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  getPlayers() {
    var players = this.players.filter(player => {
      return player.name.toLowerCase().includes(this.filter.toLowerCase());
    });

    if (this.sort == "views") {
      return players.sort(function(a, b) {
        return b.views - a.views;
      });
    } else {
      return players;
    }
  }
};
</script>

